var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatternCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 884,
    height: 194,
    viewBox: "0 0 884 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H884V194H0V0Z",
    fill: "url(#pattern0)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.0328054,
    height: 0.0448454
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4856_112418",
    transform: "scale(0.000410068 0.00186856)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4856_112418",
    width: 80,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAYCAYAAABtGnqsAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEpSURBVHgB1dnvCYMwEAXwu0zgAA7RFTq5K3QI8WszgdYrHkhpm5h/9/JAFAkv8vviiUwXMs/zzTk37ZdDxHK/rut9HMcHRSbUv22b34+inbn9HLvQGk+DhhgFiIKnQUIMAqLhaVAQudSG1BBPg4DIJTYiAzyNNSLnbkCGeBpLRM4ppvp4/jhXGUFKIHJqITXAk365qDnH5SJyShE1wtP+2sNwTj9fLaDGeCkdLRG5B7yUrlaIvCzLkzrAS+lsgeioIzyJrDleLj60lpmH/ZjkWSgyV/sdhQODp0FCDAHC4WlQEP8BwuJpEBB/AcLjaawRvwF2g6exRPwE7A5PY4V4BoTDk/6aI0gJRAWExJP+2nNcbr8AwuJJf4thOKf//S2Mine+j/hLU/pfiGAsTlVivI0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternCard);
export default __webpack_public_path__ + "static/media/Pattern-card.adffc9406731eecd05126b191ca4b54c.svg";
export { ForwardRef as ReactComponent };